























import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import Validation from './Validation';
import ValidationMessagesMixin from '@/app/common/util/ValidationMessagesMixin';
import IRemindPasswordForm from '@/app/auth/remindPassword/IRemindPasswordForm';

@Component({
  name: 'RemindPasswordForm',
  mixins: [Validation, validationMixin],
})
export default class RemindPasswordForm extends mixins(
  ValidationMessagesMixin,
) {
  public remindPasswordApi: IRemindPasswordForm = { mail: '' };

  public onRemindPassword() {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$emit('remindPassword', this.remindPasswordApi);
    }
  }
}
